<template>
  <indicator-item
    :main-value="formatValue(indicatorData.value)"
    :sub-value="formatValue(indicatorData.prevValue)"
    :main-value-color="statusColor"
    :loading="loading"
    v-bind="$props"
  >
    <template #title>
      <div class="d-flex align-center">
        <div class="mr-1">
          {{ title }}
        </div>
        <template>
          <v-icon v-if="!isEqual" :color="statusColor" small>
            {{ arrowIcon }}
          </v-icon>
          <div :style="{ color: statusColor }">
            {{ revenueGrowthRate }}%
          </div>
        </template>
      </div>
    </template>
  </indicator-item>
</template>

<script>
  import IndicatorItem from '@/components/stat/IndicatorItem.vue'
  import { formatNumberToThousandths } from '@/util/num-format'

  export default {
    name: 'DynamicsIndicatorItem',
    components: { IndicatorItem },
    props: {
      indicatorData: Object,
      title: String,
      mainValue: [String, Number],
      tooltipText: String,
      increasingStatusColor: {
        type: String,
        default: '#6BAD01',
      },
      decreasingStatusColor: {
        type: String,
        default: '#E92663',
      },
      equalStatusColor: {
        type: String,
        default: '#949191',
      },
      icon: String,
      subValue: {
        type: [String, Number],
        default: () => null,
      },
      valueType: {
        type: String,
        default: 'count',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      statusColor () {
        if (this.isEqual) {
          return this.equalStatusColor
        }

        return this.isIncreased ? this.increasingStatusColor : this.decreasingStatusColor
      },
      arrowIcon () {
        return this.isIncreased ? 'mdi-arrow-up' : 'mdi-arrow-down'
      },
      // Без изменений к прошлому периоду: ни роста, ни падения - стрелку не показываем
      isEqual () {
        return this.indicatorData.value === this.indicatorData.prevValue
      },
      isIncreased () {
        return this.indicatorData.value > this.indicatorData.prevValue
      },
      revenueGrowthRate () {
        if (this.indicatorData.prevValue === 0) {
          return 0
        }

        return parseFloat(Math.abs(
          (this.indicatorData.value - this.indicatorData.prevValue) / this.indicatorData.prevValue * 100,
        ).toFixed(1))
      },
    },
    methods: {
      formatValue (value) {
        return this.valueType === 'amount'
          ? this.$options.filters.amountWithCurrency0(value)
          : formatNumberToThousandths(value)
      },
    },
  }
</script>
